<template>
  <div>
    <a href="http://phromonglobal.com" target="_blank">
      <img :src="bannerS" class="img100 mb_40" alt="">
    </a>
    <div class="widthBox mb_80">
      <el-row :gutter="10" class="acea-row ptb_40 cursor" v-for="(item,index) in list" :key="index" @click.native="toUrl('/News_details?id='+item.id)">
            <el-col :span="2" class="hidden-xs-only">
              <div class="info2 f-20 mb_8">{{ item.m_d }}</div>
              <div class="info2">{{ item.y }}</div>
            </el-col>
            <el-col :span="13" :offset="2" :xs="14" class="hidden-xs-only">
              <div class="txt f-20 mb_8">{{ item.title }}</div>
              <div class="info">{{ item.desc   }}</div>
            </el-col>
            <el-col :span="5" :offset="2" :xs="8" class="hidden-xs-only">
                <img class="img100 radius-8" :src="item.thumbnail_url" alt="">
            </el-col>

            <el-col :xs="15" class="hidden-sm-and-up">
              <div class="txt f-20 mb_8 line_Hide_2">{{ item.title }}</div>
              <div class="info line_Hide_2">{{ item.desc }}</div>
            </el-col>
            <el-col :offset="1" :xs="8" class="hidden-sm-and-up">
                <img class="img100 radius-8" :src="item.thumbnail_url" alt="">
            </el-col>
      </el-row>
    </div>
    <div class="txt_center pageBox">
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        :page-count="count"
        @current-change="change"
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
    name:"News",
    data(){
      return{
        list:[],
        count:1,
        query:{
          page:1,
          limit:5
        }
      }
    },
		computed: {
			bannerS(){
				return this.$store.state.bannerS
			}
		},
    created(){
        this.get_info();
    },
		methods: {
			toUrl(url){
      		this.$router.push(url)
			},
      change(e){
          this.query.page = e;
          this.get_info();
      },
      async get_info(){
          let res = await this.$api.get("api/Article/list", this.query);
          this.list = res.data.article_list.list;
          this.list.forEach(item => {
            item.y = new Date(item.create_time).getFullYear();
            let m = (new Date(item.create_time).getMonth() + 1).toString().length == 1 ? "0" + (new Date(item.create_time).getMonth() + 1) : (new Date(item.create_time).getMonth() + 1);
            let d = new Date(item.create_time).getDate().toString().length == 1 ? "0" + new Date(item.create_time).getDate() : new Date(item.create_time).getDate();
            item.m_d = m + "-" + d;
          });
          this.count = res.data.article_list.pages
      }
		}
}
</script>

<style  lang="scss" scoped="scoped">
.mb_40{
  margin-bottom:40px ;
}
.mb_80{
  margin-bottom:80px ;
  border-bottom: 1px solid #E6E6E6;
}
.mb_8{
  margin-bottom: 8px;
}
.ptb_40{
  padding: 40px 0;
  border-top: 1px solid #E6E6E6;
}

@media screen and(max-width:768px) { 
  .mb_40{
    margin-bottom:32px ;
  }
  .mb_8{
    margin-bottom: 4px;
  }
  .mb_80{
    margin-bottom: 32px !important;
  }
  .ptb_40{
    padding: 20px 0;
    border-top: 1px solid #E6E6E6;
  }
}
</style>

